import { render } from "./RestoreSnapshotDialog.vue?vue&type=template&id=a4558c98&scoped=true"
import script from "./RestoreSnapshotDialog.vue?vue&type=script&lang=js"
export * from "./RestoreSnapshotDialog.vue?vue&type=script&lang=js"

import "./RestoreSnapshotDialog.vue?vue&type=style&index=0&id=a4558c98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4558c98"]])

export default __exports__